export default {
	additionalImage: 'Additional',
	damage: 'Damage',
	documents: 'Documents',
	tyres: 'Tyres',
	vehicle: 'Vehicle',
	wheels: 'Wheels',
};
